import cx from 'classnames';
import PropTypes from 'prop-types';

import ErrorPanel from 'src/components/ErrorPanel';

import { useDataContextValue } from './context';
import useStyles from './useStyles';
import { useViewModel } from './useViewModel';
import { getContentComponent } from './utils';

export const BriefFormView = ({
  className,
  content,
  onContentChange,
  onFieldFocus,
  onFieldBlur,
  errors,
  disabled,
}) => {
  const styles = useStyles();

  const { briefType, generationTool } = useDataContextValue();
  const ContentComponent = getContentComponent(briefType, generationTool);

  const { briefError, handleContentChange, refErrorPanel } = useViewModel({
    errors,
    onContentChange,
  });

  return (
    <div className={cx(styles.root, className)}>
      {briefError && (
        <ErrorPanel
          classes={{ root: styles.errorPanel }}
          ref={refErrorPanel}
          text={briefError}
        />
      )}

      <ContentComponent
        className={styles.content}
        value={content}
        onChange={handleContentChange}
        onFieldFocus={onFieldFocus}
        onFieldBlur={onFieldBlur}
        errors={errors && errors.content}
        disabled={disabled}
      />
    </div>
  );
};

BriefFormView.propTypes = {
  className: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.shape(), PropTypes.array]),
  onContentChange: PropTypes.func,
  onFieldFocus: PropTypes.func,
  onFieldBlur: PropTypes.func,
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
};

BriefFormView.defaultProps = {
  className: null,
  content: null,
  onContentChange: null,
  onFieldFocus: null,
  onFieldBlur: null,
  disabled: false,
  errors: null,
};
